<template>
    <div id="item-panel-search"
         :class="{'item-panel-search--with-query': query}">
        <input id="item-panel-search-input"
               v-model="query"
               v-select-on-focus
               class="form-control"
               type="text"
               :placeholder="placeholderText"
               @input="$emit('change', query)"
               @keydown.enter.prevent="$emit('enter', query)"
               @keydown.tab.prevent="$emit('tab')" />
        <a v-if="query"
           class="btn btn-default"
           @click.prevent="clear">
            <i class="fa-solid fa-circle-xmark" />
        </a>
    </div>
</template>

<script>
import { container } from '@/container';
import { selectOnFocus } from '@/vue/directives/selectOnFocus';

export default {
    name: 'ItemPanelSearch',

    directives: {
        selectOnFocus,
    },

    emits: [
        'enter',
        'change',
        'tab',
    ],

    data() {
        return {
            query: '',
        };
    },

    computed: {
        placeholderText() {
            return container.langService.getText('SELL.SEARCH_PLACEHOLDER');
        },
    },

    methods: {
        clear() {
            this.query = '';
            this.$emit('change', this.query);
        },
    },
};
</script>

<style lang="less">
@import "../../../../../less/variables";
@import (less, reference) "../../../../../less/vendor/fontawesome.less";

#item-panel-search {
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    height: 34px;
    position: relative;

    // Search icon to be displayed on top of the input.
    &::before {
        content: @fa-var-magnifying-glass;
        font-family: 'Font Awesome 6 Pro';
        font-weight: 900; // Make it fa-solid
        position: absolute;
        top: 50%;
        height: 22px;
        margin-top: -11px;
        left: 7px;
        color: @input-color;
        z-index: 1;
    }

    input {
        flex-grow: 1;
        flex-shrink: 1;
        height: 100%;
        padding-left: 25px;
    }

    .btn {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 41px;
        padding: 1px 0 0 0;
    }

    &.item-panel-search--with-query {
        input {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .btn {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
}
</style>
